import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import LogFormShell from "./LogFormShell";
import colors from "../../assets/theme/colors";

const formatCapturedAt = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: "UTC",
  });
};

/**
 * Reusable, domain-agnostic "View sources" sheet - the multi-record sibling
 * of HandbookSourceViewer. Receives presentation-ready records only (each
 * already resolved from a Profile Contract `provenance.records` entry); it
 * never inspects Knowledge facts or Firestore itself.
 */
const HandbookSourceListViewer = ({ open, records = [], onClose }) => {
  if (!open) return null;

  return (
    <LogFormShell
      open={open}
      onClose={onClose}
      title="View sources"
      subtitle={records.length > 1 ? `Verified by ${records.length} records` : undefined}
      maxWidth="sm"
      forceDrawer
      footer={(
        <Button
          variant="contained"
          onClick={onClose}
          fullWidth
          sx={{ textTransform: "none", fontWeight: 800, borderRadius: 999 }}
        >
          Close
        </Button>
      )}
    >
      {records.length ? (
        <Stack spacing={1.4} divider={<Box sx={{ borderTop: `1px solid ${colors.semantic.line}` }} />}>
          {records.map((record) => (
            <Stack key={record.id} spacing={0.35}>
              <Typography sx={{ fontSize: "0.98rem", fontWeight: 800, color: colors.semantic.ink }}>
                {record.label}
              </Typography>
              <Typography sx={{ fontSize: "0.76rem", fontWeight: 800, color: colors.semantic.ink2, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                {[record.authorName || 'Author not recorded', record.sourceTypeLabel, formatCapturedAt(record.capturedAt)].filter(Boolean).join(" · ")}
              </Typography>
              {record.captureId ? <Button component="a" href={`/sources/${record.captureId}`} size="small" sx={{alignSelf:"flex-start",p:0,textTransform:"none"}}>Open source note</Button> : null}
              {record.excerpt ? (
                <Typography sx={{ fontSize: "0.9rem", lineHeight: 1.55, color: colors.semantic.ink }}>
                  {record.excerpt}
                </Typography>
              ) : null}
            </Stack>
          ))}
        </Stack>
      ) : (
        <Typography sx={{ fontSize: "0.94rem", color: colors.semantic.ink2 }}>
          We can't load these sources right now. Try again in a moment.
        </Typography>
      )}
    </LogFormShell>
  );
};

export default HandbookSourceListViewer;
